//import { StandardAction } from "./Actions/StandardAction";
import { RightType } from "../../../../Global/Base/Rights/RightTypes";
import { ActionType } from "../../../UI.Controls/Actions/IAction";
import { ILogicalComponent } from "../../LogicalTree/ILogicalComponent";
import { ReportAction } from "./Actions/ReportAction";
import { StandardAction } from "./Actions/StandardAction";
import { XGAction } from "./Actions/XGAction";
import { DetailFrameRightsOverrides } from "./DetailFrameRightsOverrides";
import { ISeparateDetailFrame } from "./Frames/IDetailMasterableFrame";
import { IEditableFrame } from "./Frames/IEditableFrame";

export class SeparateDetailFrameOverrides extends DetailFrameRightsOverrides {
    protected override readonly __frame: ISeparateDetailFrameForOverrides & IEditableFrame;

    protected override get _frame(): ISeparateDetailFrameForOverrides & IEditableFrame {
        return this.__frame;
    }

    protected override _initializeOverrides(): void {
        super._initializeOverrides();

        this._registerOverrideFunctionForRightType(ReportAction, RightType.enabled, this._standardOrReportActionsEnabled);
    }

    private async _standardOrReportActionsEnabled(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const xgAction = controlWrapper.control as XGAction;

        const getInteractive = (isRetry: boolean = false): boolean | null => {
            if (this._frame.formName)
                return this._frame.interactive;

            let classRightsEnabled: boolean | null;
            if (controlWrapper.parentControlWrapper && controlWrapper.parentControlWrapper.classItemRights && controlWrapper.parentControlWrapper.classItemRights.Enabled != null) {
                classRightsEnabled = controlWrapper.parentControlWrapper.classItemRights.Enabled;
            }

            if (classRightsEnabled) {
                let result: boolean | null;
                const isActive = this._frame.masterFrame ? this._frame.masterFrame.isActive : true; // SDF má někdy masterFrame??

                result = isActive && this._frame.interactive;

                if (isRetry)
                    result = result && !this._frame.disableRetryButton;

                return result;
            }

            return null;
        };

        switch (xgAction.actionType) {
            case ActionType.standardRunMethod:
            case ActionType.standardOpenConditionForm:
            case ActionType.report:
                return getInteractive(true);
            case ActionType.standardRunMethodAndClose:
            case ActionType.standardCloseAndOpenConditionForm:
            case ActionType.reportAndClose:
                return getInteractive();
        }

        if (xgAction instanceof StandardAction)
            return await super._standardActionsEnabled(controlWrapper);

        return null;
    }

    protected override async _standardActionsEnabled(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        return this._standardOrReportActionsEnabled(controlWrapper);
    }
}

interface ISeparateDetailFrameForOverrides extends ISeparateDetailFrame {
    formName: string;
    disableRetryButton: boolean;
}
